import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({ config: {
  instrumentationKey: '2c01dcde-3805-4f9b-8c95-4aa22b58f3a0'
} });
appInsights.loadAppInsights();
appInsights.trackPageView();

import { factory } from '@opten/compiler/factory';
import { FormField } from '@opten/forms/form-field';

import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb';

import { MapExtendedComponent } from './components/map-extended/map-extended-component';
import { TabsComponent } from './components/tabs/tabs-component';
import { DomainFavoriteComponent } from './components/favorites/domainFavorite';
import { SidePanelComponent } from './components/side-panel/sidePanel';
import { VehicleSliderComponent } from './components/vehicle-slider/vehicle-slider';
import { Header } from './components/header/header';
import { KeyvisualSliderComponent } from './components/keyvisual/keyvisual-slider';
import { TheWallComponent } from './components/the-wall/the-wall';
import { MixitupComponent } from './components/mixitup';
import { IFramePlayerComponent } from './components/player/player';
import { ModalComponent } from './components/modal/modal';
import { GallerySliderComponent } from './components/gallery-slider/gallery-slider';
import { VehicleStorageComponent } from './components/vehicles-storage/vehicle-storage';
import { Navbar, NavbarToggler, NavbarMegaDropdown } from './components/navbar';
import { LanguageChooserComponent } from './components/language-chooser';
import { MagicScrollComponent } from './components/magic-scroll';
import { ScrollbarHelper } from './components/scrollbar';
import { VehiclesStorageComponent } from './components/vehicles-storage/vehicles-storage';
import { LoadContentComponent } from './components/load-content/load-content';
import { PopupDomainFavoriteComponent } from './components/favorites/popup-domain-favorite';
import { PopupDomainFavoriteLinkComponent } from './components/favorites/popup-domain-favorite-link';
import { FormLocationSellerComponent } from './components/form/form-location-seller';
import { AnchorComponent } from './components/anchor';
import { FormNewsletterComponent } from './components/form/form-newsletter';
import { CollapseComponent } from './components/collapse-component';
import { RecaptchaValidatorComponent } from './components/recaptcha/recaptcha-validator-component';
import { CookieConsentComponent } from './components/cookie-banner/cookie-consent-component';
import { NavbarMegaDropdownFavoriteAdded } from './components/navbar/navbar-mega-dropdown-favorite-added';
import { CheckboxTreeComponent } from './components/form/checkbox-tree';
import { ScrollToBottomPartPageComponent } from './components/scroll-to-bottom-part-page';
import { CountdownMediaComponent } from './components/countdown-media/countdown-media';
import { FilterSearchComponent } from './components/filter-search/filter-search';
import { GtmTrackerComponent } from './components/gtm-tracker';
import { CalculatorEnergyLsvaCostSavingsComponent } from './components/calculator-energy-lsva-cost-saving/calculator-energy-lsva-cost-saving';
import { FormGTMComponent } from './components/form/form-gtm';
import { AdventCalendarComponent } from './components/advent-calendar/advent-calendar';
import { CookiebotRenewComponent } from './components/cookiebot';
import { WindowPrintComponent } from './components/window-print';
import { NavSkiplinkComponent } from './components/header/nav-skiplinks';
import { CurrencyFieldComponent } from './components/form/currency-field';
import { VehiclesStoragePreviewComponent } from './components/vehicles-storage/vehicles-storage-preview';
import { AutocompleteZipComponent } from './components/form/form-autocomplete-zip';
import { Gallery360Component } from './components/gallery-360/gallery-360';
import { Gallery360SpinnerComponent } from './components/gallery-360-spinner/gallery-360-spinner';
import { VehicleStoragePdfComponent } from './components/vehicles-storage/vehicle-storage-pdf';
import { HighlightSliderComponent } from './components/highlight-slider';
import { KeyvisualPriceBarComponent } from './components/keyvisual/keyvisual-price-bar';
import { AutoUncleWidgetComponent } from './components/auto-uncle/auto-uncle-widget';
import { AutoUncleTradeInTriggerComponent } from './components/auto-uncle/auto-uncle-tradein-trigger';

factory([
	CookieConsentComponent,
	CookiebotRenewComponent,
	BreadcrumbComponent,
	CollapseComponent,
	Header,
	Navbar,
	NavSkiplinkComponent,
	NavbarMegaDropdown,
	NavbarMegaDropdownFavoriteAdded,
	NavbarToggler,
	LanguageChooserComponent,
	MapExtendedComponent,
	FormField,
	TabsComponent,
	DomainFavoriteComponent,
	SidePanelComponent,
	MixitupComponent,
	FilterSearchComponent,
	VehicleSliderComponent,
	KeyvisualSliderComponent,
	LoadContentComponent,
	TheWallComponent,
	AnchorComponent,
	IFramePlayerComponent,
	ModalComponent,
	GallerySliderComponent,
	GtmTrackerComponent,
	VehicleStorageComponent,
	VehiclesStorageComponent,
	CheckboxTreeComponent,
	MagicScrollComponent,
	PopupDomainFavoriteComponent,
	PopupDomainFavoriteLinkComponent,
	FormLocationSellerComponent,
	FormNewsletterComponent,
	RecaptchaValidatorComponent,
	ScrollToBottomPartPageComponent,
	CountdownMediaComponent,
	CalculatorEnergyLsvaCostSavingsComponent,
	FormGTMComponent,
	AdventCalendarComponent,
	WindowPrintComponent,
	CurrencyFieldComponent,
	VehiclesStoragePreviewComponent,
	AutocompleteZipComponent,
	Gallery360Component,
	Gallery360SpinnerComponent,
	VehicleStoragePdfComponent,
	HighlightSliderComponent,
	KeyvisualPriceBarComponent,
	AutoUncleWidgetComponent,
	AutoUncleTradeInTriggerComponent
])(document.body);

new ScrollbarHelper();
